// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Запити» (Inquiries, ключ `inquiry`, група `oversight`). */
export const inquiriesManifest: IModuleManifest = {
  key: 'inquiry',
  group: 'oversight',
  slug: 'inquiries',
  prefix: 'INQ',
  name: { en: 'Inquiries', uk: 'Запити' },
  entities: [
    { key: 'inquiry', slug: 'inquiry', name: { en: 'Inquiries', uk: 'Запити' }, main: true },
    { key: 'inquiry_addressee', slug: 'inquiry-addressee', name: { en: 'Inquiry Addressees', uk: 'Адресати' }, main: false },
    { key: 'inquiry_answer', slug: 'inquiry-answer', name: { en: 'Inquiry Answers', uk: 'Відповіді' }, main: false },
    { key: 'inquiry_deadline', slug: 'inquiry-deadline', name: { en: 'Inquiry Deadlines', uk: 'Строки' }, main: false },
    { key: 'inquiry_evidence', slug: 'inquiry-evidence', name: { en: 'Inquiry Evidences', uk: 'Докази' }, main: false },
    { key: 'inquiry_status', slug: 'inquiry-status', name: { en: 'Inquiry Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/inquiriesSlice').then((m) => m.inquiriesSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
